// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"nY-z","sponsoredTooltipWrapper":"oY-z","sponsoredTooltip":"pY-z","newCard":"qY-z"};